"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { Link } from "gatsby";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ContactForm } from "./ContactForm"; // Importación nombrada

export default function DrawerWithForm({
  buttonClasses = "",
  municipioInicial = "",
  text = "Solicita Presupuesto",
}) {
  const [open, setOpen] = useState(false);

  // Función para abrir el panel deslizante evitando la navegación en JS
  const handleClick = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <React.Fragment>
      {/* Enlace visible que abre el panel */}
      <Link
        to="/contacto/"
        onClick={handleClick}
        className={`btn relative group ${buttonClasses}`}
        rel="nofollow"
      >
        {text}
        <span className="absolute normal-case top-full whitespace-nowrap left-1/2 -translate-x-1/2 mt-1 px-3 py-2 rounded text-xs  text-white bg-blue-700 opacity-0 group-hover:opacity-100 transition-all duration-200 text-center shadow">
          Presupuesto sin compromiso
          <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-blue-700" />
        </span>
      </Link>

      {/* Panel deslizante */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="relative z-[100]"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black/50 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <DialogTitle className="text-base font text-slate-900">
                        Solicita Presupuesto{" "}
                        <strong className="font-bold">Sin Compromiso</strong>
                      </DialogTitle>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#3B74D9] focus:ring-offset-2"
                        >
                          <span className="sr-only">Cerrar panel</span>
                          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="relative flex-1 px-4 sm:px-6">
                    {/* Se pasa la función onClose para cerrar el panel desde el formulario */}
                    <ContactForm
                      onClose={() => setOpen(false)}
                      municipioInicial={municipioInicial}
                    />
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
